import { render } from "./Physicians.vue?vue&type=template&id=4d59b52d&scoped=true"
import script from "./Physicians.vue?vue&type=script&lang=js"
export * from "./Physicians.vue?vue&type=script&lang=js"

import "./Physicians.vue?vue&type=style&index=0&id=4d59b52d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d59b52d"]])

export default __exports__